module.exports = __webpack_public_path__ + "static/media/Cats eyes 06_TYSKA-mixdown.d4b6b8ab.mp3";